import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {styled} from "@mui/styles";
import {AppBar, BottomNavigation, BottomNavigationAction, Drawer, Stack, Typography} from "@mui/material";
import {
    CalendarMonth as CalendarIcon,
    MoreHoriz as MoreIcon,
    Paid as OfferingsIcon,
    People as NodesIcon
} from "@mui/icons-material";
import {MoreMenu} from "../nav";
import {router} from "@atttomyx/react-utils";
import {arrays, strings} from "@atttomyx/shared-utils";
import {
    PAGE_CALENDAR,
    PAGE_NODE,
    PAGE_NODES,
    PAGE_OFFERINGS,
    PAGE_USER,
    PAGES_MAIN,
    PAGES_MORE,
} from "../../constants";
import "./footer.css";

const ActiveMoreIcon = styled(MoreIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveMoreIcon = styled(MoreIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActiveCalendarIcon = styled(CalendarIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveCalendarIcon = styled(CalendarIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActiveNodesIcon = styled(NodesIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveNodesIcon = styled(NodesIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const ActiveOfferingsIcon = styled(OfferingsIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));
const InactiveOfferingsIcon = styled(OfferingsIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const PAGE_MORE = "more";
const PAGE_OTHER = "other";

const NavButton = (props) => {
    const { label, active, icon, onClick } = props;

    return (
        <Stack direction="column" onClick={onClick} className="nav-button">
            {icon}
            <Typography variant="caption" color={active ? "primary" : "text.secondary"}>
                {label}
            </Typography>
        </Stack>
    )
};

const Footer = (props) => {
    const {snackbar, dimensions, history, accounts, account, user, onLogout, onSwitchAccounts} = props;
    const [showMore, setShowMore] = useState(false);

    useEffect(() => {
        dimensions.onResize();
    }, []);

    const path = strings.sanitizeStr(router.getCurrentPage(history));
    let page = PAGE_OTHER;

    if (arrays.contains(PAGES_MAIN, path)) {
        page = path;

    } else if (arrays.contains(PAGES_MORE, path)) {
        page = PAGE_MORE;

    } else if (path === PAGE_USER || path.startsWith(PAGE_USER + "/")) {
        page = PAGE_MORE;

    } else if (path === PAGE_NODE || path.startsWith(PAGE_NODE + "/")) {
        page = PAGE_NODES;
    }

    const renderBottom = () => {
        return (
            <AppBar className="bottom-nav" position="fixed" color="default">
                <BottomNavigation
                    value={page}
                    showLabels={true}
                >
                    <BottomNavigationAction
                        value={PAGE_NODES}
                        label="Members"
                        icon={<NodesIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_NODES)}
                    />
                    {user.roles.admin || user.roles.deacon ?
                        <BottomNavigationAction
                            value={PAGE_OFFERINGS}
                            label="Offerings"
                            icon={<OfferingsIcon/>}
                            onClick={() => router.redirectTo(history, PAGE_OFFERINGS)}
                        /> : null}
                    {user.roles.admin || user.roles.secretary ?
                        <BottomNavigationAction
                            value={PAGE_CALENDAR}
                            label="Calendar"
                            icon={<CalendarIcon/>}
                            onClick={() => router.redirectTo(history, PAGE_CALENDAR)}
                        /> : null}
                    <BottomNavigationAction
                        value={PAGE_MORE}
                        label="More"
                        icon={<MoreIcon/>}
                        component="div"
                        onClick={() => setShowMore(true)}
                    />
                </BottomNavigation>
            </AppBar>
        )
    };

    const renderLeft = () => {
        return (
            <Drawer
                variant="permanent"
                anchor="left"
                open={false}
                className="left-nav"
            >
                <div className="nav-buttons">
                    <NavButton
                        label="Members"
                        active={page === PAGE_NODES}
                        icon={page === PAGE_NODES ? <ActiveNodesIcon/> : <InactiveNodesIcon/>}
                        onClick={() => router.redirectTo(history, PAGE_NODES)}
                    />
                    {user.roles.admin || user.roles.deacon ?
                        <NavButton
                            label="Offerings"
                            active={page === PAGE_OFFERINGS}
                            icon={page === PAGE_OFFERINGS ? <ActiveOfferingsIcon/> : <InactiveOfferingsIcon/>}
                            onClick={() => router.redirectTo(history, PAGE_OFFERINGS)}
                        /> : null}
                    {user.roles.admin || user.roles.secretary ?
                        <NavButton
                            label="Calendar"
                            active={page === PAGE_CALENDAR}
                            icon={page === PAGE_CALENDAR ? <ActiveCalendarIcon/> : <InactiveCalendarIcon/>}
                            onClick={() => router.redirectTo(history, PAGE_CALENDAR)}
                        /> : null}
                    <NavButton
                        label="More"
                        active={page === PAGE_MORE}
                        icon={page === PAGE_MORE ? <ActiveMoreIcon/> : <InactiveMoreIcon/>}
                        onClick={() => setShowMore(true)}
                    />
                </div>
            </Drawer>
        )
    };

    return <div className="footer">
        {dimensions.landscape && dimensions.short ? renderLeft() : renderBottom()}
        {showMore ?
            <MoreMenu
                snackbar={snackbar}
                accounts={accounts}
                account={account}
                user={user}
                onCancel={() => setShowMore(false)}
                onLogout={onLogout}
                onSwitchAccounts={onSwitchAccounts}
            /> : null}
    </div>
}

export default withRouter(Footer);
